import {
    Container,
    Box
} from '@mui/material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import QrCodeIcon from '@mui/icons-material/QrCode';
import LaunchIcon from '@mui/icons-material/Launch';

import { useBags } from '../api/useBags';
import { TypographyBagStatus } from '@features/typography-colored-status-bag';
import { Alert } from '@features/alert';
import { formatISOToCustom, isISO8601 } from '@shared/api/utils';
import React from 'react';
import { LoadingPage } from '@widgets/loading-page';

export const BagsViewPage = () => {
    const {
        alertRef,
        rows,
        handleOpen,
        handleOpenQr,
        isLoading
    } = useBags();

    if (isLoading) return <LoadingPage/>;

    const columns = [
        {
            field: 'actions',
            type: 'actions',
            headerName: '',
            width: 20,
            cellClassName: 'actions',
            hideSortIcons: true,
            getActions: ({ row }) => {
                return [
                    <GridActionsCellItem
                        icon={<LaunchIcon/>}
                        label="open"
                        onClick={() => handleOpen(row._id)}
                        color="inherit"
                        showInMenu
                    />,
                    <GridActionsCellItem
                        icon={<QrCodeIcon/>}
                        label="qr code"
                        onClick={() => handleOpenQr(row._id)}
                        color="inherit"
                        showInMenu
                    />
                ];
            }
        },
        {
            field: '_id',
            hideSortIcons: true,
            headerName: 'id', width: 70, valueGetter: (params) => params.slice(-5)
        },
        {
            field: 'adjustedWeight',
            type: 'number',
            headerName: 'weight',
            width: 80,
            hideSortIcons: true,
            valueGetter: (params) => {
                if (params === 0) {
                    return '';
                }
                return params;
            }
        },
        {
            field: 'status',
            headerName: 'status',
            width: 100,
            hideSortIcons: true,
            renderCell: (params) => (
                <TypographyBagStatus status={params.value} sx={{ height: '100%', alignContent: 'center' }}/>
            )
        },
        {
            field: 'arrivalDate',
            headerName: 'arrival date',
            width: 130,
            hideSortIcons: true,
            valueFormatter: (value) => {
                if (isISO8601(value)) {
                    return formatISOToCustom(value);
                }
                return value;
            }
        },
        {
            field: 'lotNumber', headerName: 'lot number',
            hideSortIcons: true,
            width: 150
        },
        {
            field: 'country', headerName: 'country', width: 150,
            hideSortIcons: true,
            valueGetter: (params) => params?.name
        },
        {
            field: 'region', headerName: 'region',
            hideSortIcons: true,
            width: 150
        },
        {
            field: 'producerName', headerName: 'producer name',
            hideSortIcons: true,
            width: 150
        },
        {
            field: 'harvest', headerName: 'harvest',
            hideSortIcons: true,
            width: 150
        },
        {
            field: 'type', headerName: 'type',
            hideSortIcons: true,
            width: 100, valueGetter: (params) => params?.name
        },
        {
            field: 'variety',
            headerName: 'variety',
            width: 220,
            hideSortIcons: true,
            valueGetter: (params) => {
                if (params.length === 0) {
                    return '';
                }
                return params.map(v => v?.name);
            }
        },
        {
            field: 'processing',
            hideSortIcons: true,
            headerName: 'processing', width: 150, valueGetter: (params) => params?.name?.en
        },
        {
            field: 'qGrade',
            type: 'number',
            headerName: 'q-grade',
            width: 70,
            hideSortIcons: true,
            valueGetter: (params) => {
                if (params === 0) {
                    return '';
                }
                return params;
            }
        }
    ];

    return (
        <>
            <Container
                maxWidth="false"
                sx={{
                    width: '100%',
                    padding: { xs: 1, sm: 2, md: 3 },
                    height: '80vh'
                }}
            >
                <Box
                    sx={{
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        editMode="row"
                        getRowId={(row) => row._id}
                        sx={{
                            '& .MuiTablePagination-root': {
                                overflow: 'hidden',
                            },
                            '& .MuiTablePagination-root .MuiTablePagination-selectLabel': {
                                textTransform: 'lowercase'
                            },
                        }}
                    />
                </Box>
            </Container>
            <Alert ref={alertRef}/>
        </>
    );
};
